import React from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Grid } from "@material-ui/core";
import {
  ButtonHLPure,
  InstructionsPure
} from "../../pures";
import "./dialogFormHL.css";

const DialogFormHLPure = (props) => {
  const {
    showChildrenBottom, //Shot button 
    childrenBottom,//Show button container dialog
    cancel, //Function to open or close dialog
    textBtnCancel, //Text secondary button, string, example "Cancelar"
    saveBtn, //Text to primary button, string, example "Guardar"
    titleDialog, //Title dialog string
    descriptionActive, //true to show description or false not show
    descriptionDialog, // description dialog, gray container
    loadingComponent, //Loading component
    handleSubmit, //Function to submit dialog
    saveError, //error true or false
    textBtnCancelDisabled, //true to disabled, false active
    saveBtnDisabled, //true to disabled, false active
    children, //Children, create to component body
  } = props;
  let dialogCollaboratorWidth = loadingComponent ? 590 : 740;
  let dialogCollaboratorHeight = loadingComponent ? 430 : "auto";

  // const [isLoading, setIsLoading] = useState(false);
  // const [visible, setVisible] = useState(false);

  //Function to open or close dialog
  // const toggleDialog = () => {
  //   setVisible(!visible);
  // };

  return (
    <Dialog
      className={`dialogFormHLPure-container ${props.className}`}
      width={dialogCollaboratorWidth}
      height={dialogCollaboratorHeight}
      title={titleDialog}
      onClose={cancel}
    >
      {/* {loadingComponent && (
        // <div>
        //   <SimpleLoading />
        // </div>
        <DialogSystemGLPure showLoadingRequesting={loadingComponent} toggleLoadingRequesting={loadingComponent}/>
      )} */}
      {/* {!saveError && !loadingComponent && (
        // <form> */}
      <div
        className={
          descriptionActive === false
            ? "dialogFormHLPure-bodyDialog-notDescription"
            : "dialogFormHLPure-bodyDialog"
        }
      >
        {descriptionActive ? (
          <InstructionsPure instructions={[descriptionDialog]} />
        ) : (
          ""
        )}
        {children}
        {(saveBtn && textBtnCancel) ? (
          <Grid
            xs={12}
            lg={12}
            md={12}
            sm={12}
            es={12}
            className="dialogFormHLPure-btns-container"
          >
            <Grid className="dialogFormHLPure-btnCancel">
              <ButtonHLPure
                nameBtn={textBtnCancel}
                onClickBtn={cancel}
                primary={false}
                disabled={textBtnCancelDisabled}
              />
            </Grid>
            <ButtonHLPure
              primary={true}
              nameBtn={saveBtn}
              onClickBtn={handleSubmit}
              disabled={saveBtnDisabled}
            />
          </Grid>
        )
          : null}
      </div>
      {/* // </form> */}
      {/* // )} */}
      {childrenBottom && showChildrenBottom && !loadingComponent ? (
        <DialogActionsBar>
          {childrenBottom}
        </DialogActionsBar>
      ) : null}
    </Dialog>
  );
};

export { DialogFormHLPure as default };
